<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>物料管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="backHref">总仓盘点单</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!showIsAdd && !showIsDetail">
      <section class="searchBox">
        <span class="addStyle">
          <a-button
            @click="showIsAdd = !showIsAdd"
            style="margin-right: 20px"
            type="primary"
            icon="plus"
            >盘点</a-button
          >
        </span>
        <span>
          <label>项目：</label>
          <a-select
            v-model="project_id"
            style="width:200px"
            showSearch
            :filterOption="filterOption"
            optionFilterProp="children"
            placeholder="请选择项目"
          >
            <a-select-option
              v-for="(item, i) in proList"
              :key="i"
              :value="item.id"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>盘点日期：</label>
          <a-range-picker @change="onChangeDate" v-model="dateVal" />
        </span>
        <span>
          <label>字符串：</label>
          <a-input
            placeholder="请输入盘点编号|盘点人手机号|盘点人姓名"
            style="width:300px"
            v-model="query_field"
          />
        </span>
        <span>
          <a-button class="resetStyle" @click="downloadCost">
            <a-icon type="vertical-align-bottom" />下载
          </a-button>
          <a-button @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="(item, j) in thList" :key="j">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.length < 1">
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <!-- <td>{{ item.project_name }}</td> -->
              <td>{{ item.check_date }}</td>
              <td>{{ item.no }}</td>
              <td>{{ item.create_time }}</td>
              <td>{{ item.user_name }}</td>
              <td class="operation">
                <a @click="detailPage(item)" style="color:#777">详情</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- content end -->
    <!-- 增加 -->
    <addWarehouseCheckOrder v-show="showIsAdd" v-on:hideInAdd="hideInAdd" />
    <!-- 增加 end -->
    <!-- 详情 -->
    <warehouseCheckOrderDetail v-show="showIsDetail" :detailVal="detailVal" />
    <!-- 详情 end -->
  </div>
</template>
<script>
import axios from "axios";
import addWarehouseCheckOrder from "@/components/equipment/addWarehouseCheckOrder"; //增加
import warehouseCheckOrderDetail from "@/components/equipment/warehouseCheckOrderDetail"; //详情
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: ["盘点日期", "单号", "创建日期", "操作人", "操作"],
      project_id: "",
      query_field: "",
      isHideDetails: false,
      details: {},
      showIsAdd: false,
      proList: [],
      showIsDetail: false,
      detailVal: "",
      start_date: "",
      end_date: "",
      dataVal: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    addWarehouseCheckOrder,
    warehouseCheckOrderDetail
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro(); //获取项目
  },
  methods: {
    downloadCost() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Project_check/downloadLists?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&query_field=" +
        this.query_field +
        "&start_date=" +
        this.start_date +
        "&end_date=" +
        this.end_date +
        "&project_id=" +
        this.project_id;
    },
    onChangeDate(date, dateString) {
      this.start_date = dateString[0];
      this.end_date = dateString[1];
    },
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    hideInAdd(msg) {
      this.showIsAdd = false;
      if (msg) {
        this.reload();
      }
    },
    backHref() {
      this.showIsDetail = false;
      this.showIsAdd = false;
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onReset() {
      this.query_field = "";
      this.project_id = "";
      this.dateVal = null;
      this.start_date = "";
      this.end_date = "";
      this.page = 1;
      this.getData();
    },
    getData() {
      this.loading = true;
      let url =
        this.httpsBasic.url + this.httpsBasic.equipment + "Project_check/lists";
      let params = {
        current_page: this.page,
        per_page: 10,
        query_field: this.query_field,
        project_id: this.project_id,
        start_date: this.start_date,
        end_date: this.end_date,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    detailPage(item) {
      this.detailVal = item;
      this.showIsDetail = true;
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  td {
    img {
      height: 30px;
      width: 30px;
      object-fit: cover;
    }
  }
}
</style>
